import React, { useState, useCallback, useEffect } from 'react'
import Spinner from './spinner'

function LodgingItinerary({index, itinerary, onChange, onDelete}) {  
  const [nights, setNights] = useState(itinerary.nights)
  const [rooms, setRooms] = useState(itinerary.rooms)

  const calculateEmissions = (data)=>{
    onChange(index, data)
  }

  return (
    <div>
      {index!=0?(
        <div className="subsection">          
          Additional lodging
          <span onClick={()=>onDelete(index)} className="selectable" aria-hidden="true">&times;</span>
        </div>
      ):""}      
      <Spinner className={"lodging "+(index==0?"large":"")} min={0}  label={index==0?"How many nights did you stay on your trip?":"Number of nights"} value={nights} onChange={(i)=>{setNights(i); calculateEmissions({nights:i, rooms})}}/>
      <Spinner className={"lodging "+(index==0?"large":"")} min={0}  label={index==0?"How many rooms did you have?":"Number of rooms"} sublabel={index==0?"(If you rented a house or condo, how many bedrooms?)":null} value={rooms} onChange={(i)=>{setRooms(i); calculateEmissions({rooms:i, nights})}}/>      
      
    </div>

  )


}


export default LodgingItinerary